<template>
  <div class="t-work-area__cell">
    <h2>{{ commentsText.title }}</h2>
    <div class="t-commentsList">
      <div class="t-comment"
           v-for="item in comments.items"
           :key="'comment_' + item.id"
           :class="{_disabled: item.remote}">
        <div class="t-comment__header">
          <p class="t-comment__author">{{ item.author }}</p>
          <p class="t-comment__date">{{ item.dateTime }}</p>
          <p class="t-comment__complaint" v-if="item.complaint">{{ commentsText.complaint }}</p>
        </div>
        <div class="t-comment__text" v-if="item.remote">
          {{ commentsText.remote }}
        </div>
        <template v-else>
          <div class="t-comment__text" v-html="item.text" :class="{_highlight: highlight === item.id}"></div>
          <div class="t-comment__footer">
            <button @click.prevent="answer = {id: item.id, author: item.author}" v-if="!item.canDelete && hasAuth">{{ commentsText.addAnswer }}</button>
            <button @click.prevent="Delete(item.id)" v-if="item.canDelete && hasAuth">{{ commentsText.deleteComment }}</button>
            <button @click.prevent="Complaint(item.id)" v-if="!item.canDelete && hasAuth && !item.complaint">{{ commentsText.addComplaint }}</button>
          </div>
          <div class="t-comment__child" v-if="item.child.length">
            <div class="t-comment"
                 v-for="child in item.child"
                 :key="'comment_' + child.id"
                 :class="{_disabled: child.remote}">
              <div class="t-comment__header">
                <p class="t-comment__author">
                  {{ child.author }}
                  <span>{{ commentsText.answer }}</span>
                  <a :href="'?com=' + child.answer.id" @click.prevent="GoTo(child.answer.id)">{{ child.answer.author }}</a>
                </p>
                <p class="t-comment__date">{{ child.dateTime }}</p>
                <p class="t-comment__complaint" v-if="child.complaint">{{ commentsText.complaint }}</p>
              </div>
              <div class="t-comment__text" v-if="child.remote">
                {{ commentsText.remote }}
              </div>
              <template v-else>
                <div class="t-comment__text" :class="{_highlight: highlight === child.id}" v-html="child.text"></div>
                <div class="t-comment__footer">
                  <button @click.prevent="answer = {id: child.id, author: child.author}" v-if="!child.canDelete && hasAuth">{{ commentsText.addAnswer }}</button>
                  <button @click.prevent="Delete(child.id)" v-if="child.canDelete && hasAuth">{{ commentsText.deleteComment }}</button>
                  <button @click.prevent="Complaint(child.id)" v-if="!child.canDelete && hasAuth && !child.complaint">{{ commentsText.addComplaint }}</button>
                </div>
              </template>
            </div>
          </div>
        </template>
      </div>
    </div>
    <cmp-form :answer="answer" @ClearAnswer="ClearAnswer()" v-if="hasAuth"></cmp-form>
    <cmp-pagination class="t-pagination_comments" v-if="comments._meta.pageCount > 1" :pages="comments._meta.pageCount"></cmp-pagination>
  </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import Form from './Form.vue'
    import Pagination from '../Pagination.vue'

    export default {
        data(){
            return {
                answer: null,
                highlight: null
            }
        },
        components: {
            'cmp-form': Form,
            'cmp-pagination': Pagination
        },
        computed: {
            ...mapGetters('staticText', ['commentsText']),
            ...mapGetters('coursesList', ['course', 'comments']),
            ...mapGetters('profile', ['hasAuth'])
        },
        methods: {
            ...mapActions('coursesList', ['LoadComments']),
            ...mapActions('msg', ['showMsg']),
            ClearAnswer(){
                this.answer = null;
            },
            GoTo(id){
                this.highlight = id;
                setTimeout(() => {
                    this.highlight = null;
                }, 500);
            },
            Delete(id){
                this.$http.delete('courses/' + this.course.id + '/comments/' + id)
                    .then(response => response.json())
                    .then(data => {
                        if (data.success){
                            this.showMsg(this.commentsText.msgDelete);
                            this.LoadComments({id: this.course.id, page: this.$route.query.page});
                        } else{
                            this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                        }
                    })
                    .catch(error => {
                        this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                    });
            },
            Complaint(id){
                this.$http.put('courses/' + this.course.id + '/comments/' + id + '/complaint')
                    .then(response => response.json())
                    .then(data => {
                        if (data.success){
                            this.showMsg(this.commentsText.msgComplaint);
                            this.LoadComments({id: this.course.id, page: this.$route.query.page});
                        } else{
                            this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                        }
                    })
                    .catch(error => {
                        this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                    });
            }
        }
    }
</script>

<style lang="sass">
.t-commentsList
  margin-top: 24px
  padding-bottom: 28px
  margin-bottom: 30px
  border-bottom: 1px solid $input
.t-comment
  width: 100%
  line-height: 1.2
  &:not(:last-child)
    margin-bottom: 28px
  &__header
    display: flex
    align-items: baseline
    flex-wrap: wrap
    > *
      margin-bottom: 8px
  &__author
    font-size: 16px
    font-weight: bold
    color: $blue
    margin-right: 12px
    span
      font-weight: normal
      font-size: 12px
      color: $grey
      margin: 0 12px
      display: inline-block
    a
      color: $blue
  &__date
    font-size: 12px
    margin-right: 12px
  &__complaint
    font-size: 12px
    color: $warning
  &__text
    margin: 0 0 8px
    font-size: 14px
    transition: color .2s
    &._highlight
      color: $accented
  &__footer
    display: flex
    align-items: baseline
    button
      background: transparent
      border: none
      outline: none
      cursor: pointer
      font-size: 14px
      font-weight: bold
      font-family: 'rubik', Arial, sans-serif
      margin-right: 16px
      color: $black
  &__child
    margin-top: 28px
    margin-left: 32px
    border-left: 1px solid $input
    .t-comment
      padding-left: 24px
      position: relative
      &:before
        content: ''
        width: 9px
        height: 10px
        background: url('/img/answer.png') no-repeat center
        position: absolute
        top: 3px
        left: 12px
  &._disabled
    .t-comment__author
      color: $grey
      a
        color: $grey

.t-pagination_comments
  margin: 24px auto -56px
  position: relative
  top: 32px
  justify-content: center
</style>


// WEBPACK FOOTER //
// src/vue_components/Comments/Index.vue